import { BadgeProps, BadgeLabelProps } from '@procore/core-react/dist/_typedoc/Badge/Badge.types.json';
import * as React from 'react';
export default {
  BadgeProps,
  BadgeLabelProps,
  React
};